import * as React from "react"
import type { SVGProps } from "react"
const SvgMusicNote = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M10 21.29q-1.65 0-2.82-1.18Q6 18.94 6 17.3c0-1.65.4-2.05 1.18-2.83A4 4 0 0 1 10 13.3q.57 0 1.06.13.5.14.94.42V4.29q0-.43.29-.72A1 1 0 0 1 13 3.3h4q.42 0 .71.28.3.3.29.72v2q0 .43-.29.7a1 1 0 0 1-.71.3h-3v10q0 1.65-1.17 2.82A4 4 0 0 1 10 21.3" />
  </svg>
)
export default SvgMusicNote
